import { render, staticRenderFns } from "./LoadBuilderTemplate.vue?vue&type=template&id=3ff437d0"
import script from "./LoadBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./LoadBuilderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports